/* ============================================================================
   Veyra · la bolsa · 2026-08-25
   Braulio: "cuando clickean apartar mi bolsa se abre otra ventana, quiero que
   sea una ventana emergente al menos en compu, y que cuando se clickee se haga
   una animacion hacia el carrito".

   Tres cosas y ninguna mas:
     1 · el <form> deja de navegar: anade por /cart/add.js y abre el cajon
     2 · una foto del producto vuela hasta la bolsa de la nav
     3 · dentro del cajon se cambia cantidad y se quita, sin recargar

   LA REGLA QUE GOBIERNA EL ARCHIVO: sin este script la tienda funciona igual
   que ayer. El <form> sigue posteando a /cart/add y el <a> de la nav sigue
   llevando a /cart. Y si el fetch falla A MITAD, se hace forma.submit() y que
   el navegador termine la compra por la via de siempre — un cajon es una
   comodidad, y perder una venta por una comodidad no.
   ========================================================================== */
(function () {
  'use strict';

  var cajon = document.querySelector('[data-vy-cajon]');
  if (!cajon) return;

  var panel   = cajon.querySelector('.vy-bolsa__panel');
  var quieto  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var devolver = null;   // a quien se le devuelve el foco al cerrar

  /* --- abrir y cerrar ----------------------------------------------------- */

  /* El bloqueo del scroll NO puede ser overflow:hidden sobre <body> y ya:
     Horizon no scrollea la ventana, scrollea DIV.page-wrapper (medido el
     2026-08-21). Y `hidden` sobre un ancestro mata el position:sticky de la
     columna de compra — `clip` recorta igual y no lo rompe. Las dos cosas las
     hace la clase .vy-bolsa-abierta en veyra.css; aqui solo se pone. */
  function abrir() {
    if (!cajon.hasAttribute('hidden')) return;
    devolver = document.activeElement;
    cajon.removeAttribute('hidden');
    // Dos cuadros de margen: la clase que dispara la transicion tiene que
    // entrar DESPUES de que el nodo ya no este `hidden`, o no hay transicion.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { cajon.classList.add('vy-bolsa--vista'); });
    });
    document.documentElement.classList.add('vy-bolsa-abierta');
    panel.focus();
  }

  function cerrar() {
    if (cajon.hasAttribute('hidden')) return;
    cajon.classList.remove('vy-bolsa--vista');
    document.documentElement.classList.remove('vy-bolsa-abierta');
    var fin = function () { cajon.setAttribute('hidden', ''); };
    if (quieto) fin();
    else setTimeout(fin, 320);
    if (devolver && devolver.focus) devolver.focus();
    devolver = null;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vy-cerrar]')) { e.preventDefault(); cerrar(); return; }
    var boton = e.target.closest('[data-vy-bolsa]');
    if (boton) { e.preventDefault(); abrir(); }
  });

  document.addEventListener('keydown', function (e) {
    if (cajon.hasAttribute('hidden')) return;
    if (e.key === 'Escape') { cerrar(); return; }
    if (e.key !== 'Tab') return;

    /* Trampa de foco. Se recalcula en cada Tab a proposito: el contenido del
       cajon se reemplaza entero cada vez que cambia el carrito, asi que una
       lista guardada al abrir apuntaria a nodos que ya no existen. */
    var focos = panel.querySelectorAll(
      'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!focos.length) return;
    var primero = focos[0], ultimo = focos[focos.length - 1];
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  });

  /* --- repintar la bolsa --------------------------------------------------
     Section Rendering API. Verificado el 2026-08-25 contra la tienda: una
     seccion se renderiza suelta POR SU TIPO aunque viva en un section group
     (`?sections=vy-nav` da HTML; `?sections=nav`, la clave del grupo, da null).
     Las dos van en UNA sola peticion: 3 KB contra los 120 KB que pesa navegar
     a /cart. De vy-nav solo se lee el numero, no se cambia el nodo — la nav
     lleva el logo y los enlaces, y reemplazarla entera por un digito es mover
     mucho para nada. */
  function repintar() {
    return fetch('/?sections=vy-carrito,vy-nav', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(
          (j['vy-carrito'] || '') + (j['vy-nav'] || ''), 'text/html');

        var nuevo = doc.querySelector('[data-vy-cajon-contenido]');
        var viejo = cajon.querySelector('[data-vy-cajon-contenido]');
        if (nuevo && viejo) viejo.replaceWith(nuevo);

        /* `data-vy-bolsa-n` y no `data-vy-cuenta`: ese ya existe en la pagina
           —lo usa el conteo de cifras de veyra-motion.js, cuatro veces en la
           home— y aunque alli va acotado a .vy-decl__cifra, dos atributos con
           el mismo nombre y dos duenos distintos es una trampa esperando. */
        /* 2026-10-07: la fecha de «llega» (veyra-llega.js) se repinta con el cajón */
        document.dispatchEvent(new CustomEvent('vy:carrito-pintado'));
        var fuente = doc.querySelector('[data-vy-bolsa-n]');
        var cuenta = document.querySelector('.vy-nav [data-vy-bolsa-n]');
        if (fuente && cuenta) {
          cuenta.textContent = fuente.textContent;
          cuenta.setAttribute('data-vy-bolsa-n', fuente.getAttribute('data-vy-bolsa-n'));
        }
      });
  }

  /* --- el vuelo -----------------------------------------------------------
     Un cajon que aparece no dice de donde vino. El vuelo lo dice.

     Origen  · la foto del producto de esa misma columna si esta a la vista;
               si no —barra fija, telefono con la foto ya pasada— el boton.
     Destino · el icono de la bolsa en la nav si esta a la vista.
     Y si no · la esquina superior derecha de la ventana. NO es un apano: la
               nav no es fija, y a la altura de la seccion de compra lleva
               miles de pixeles fuera de pantalla. Volar hacia un icono que no
               esta en pantalla es aterrizar en la nada. La esquina ademas
               encadena con el cajon, que entra por ese mismo lado medio
               segundo despues: el ojo ya esta mirando ahi. */
  function aLaVista(el) {
    if (!el) return null;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    if (r.bottom < 0 || r.top > window.innerHeight) return null;
    return r;
  }

  function volar(forma, boton) {
    if (quieto) return Promise.resolve();

    var col = forma.closest('.vy-producto') || forma.parentElement;
    /* LA FOTO QUE SE VE, no la primera del DOM · 2026-10-06. Con dos sabores la
       primera imagen de la tira no siempre es la bolsa: en Vanilla es la lamina
       de beneficios, y era esa la que volaba al carrito. Se busca la lamina del
       radio marcado; si no hay galeria de radios, vale la de siempre. */
    var marcado = col ? col.querySelector('.vy-gal__r:checked') : null;
    var foto = marcado
      ? col.querySelector('.vy-gal__foto[data-g="' + marcado.id.split('-').pop() + '"] img')
      : null;
    if (!foto) foto = col ? col.querySelector('.vy-galeria img, img') : null;
    var desde = aLaVista(foto) || boton.getBoundingClientRect();
    var src = (foto && foto.currentSrc) || foto && foto.src || cajon.getAttribute('data-vy-pouch');
    if (!src) return Promise.resolve();

  /* --- El rebote de la bolsa · WAAPI desde el 2026-09-01 -------------------
     Era `classList.add('vy-nav__bolsa--late')` con un `setTimeout` de 460 ms
     para retirarla. Agregar un segundo producto mientras el primero aterrizaba
     hacia `add` sobre una clase YA PUESTA —que no reinicia la animacion— y
     encima el `setTimeout` del primer vuelo la quitaba a mitad del segundo: el
     segundo aterrizaje se perdia en silencio.

     WAAPI es lo que este mismo archivo ya usa para el vuelo. Y no se arranca en
     1: se lee la escala en curso y el rebote nuevo SALE DE AHI. Cancelar y
     empezar en 1 seria el mismo salto que tenia el @keyframes.
     ---------------------------------------------------------------------- */
  var rebote = null;
  function rebotar(el) {
    var desde = 1;
    if (rebote) {
      var t = window.getComputedStyle(el).transform;
      var a = (t && t.indexOf('matrix') === 0) ? parseFloat(t.slice(t.indexOf('(') + 1)) : NaN;
      if (a > 0.5 && a < 2) desde = a;
      rebote.cancel();
    }
    rebote = el.animate([
      { transform: 'scale(' + desde + ')' },
      { transform: 'scale(1.22)', offset: .38 },
      { transform: 'scale(1)' }
    ], { duration: 460, easing: 'cubic-bezier(.2,.8,.2,1)' });
  }

    var icono = document.querySelector('.vy-nav__bolsa-icono');
    var meta  = aLaVista(icono);
    var haciaX = meta ? meta.left + meta.width / 2 : window.innerWidth - 34;
    var haciaY = meta ? meta.top + meta.height / 2 : 34;

    var lado = Math.min(desde.width, desde.height, 180) || 120;
    var g = document.createElement('img');
    g.className = 'vy-vuelo';
    g.src = src;
    g.alt = '';
    g.style.width = lado + 'px';
    g.style.height = lado + 'px';
    g.style.left = (desde.left + desde.width / 2 - lado / 2) + 'px';
    g.style.top  = (desde.top + desde.height / 2 - lado / 2) + 'px';
    document.body.appendChild(g);

    var dx = haciaX - (desde.left + desde.width / 2);
    var dy = haciaY - (desde.top + desde.height / 2);

    var vuelo = g.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + (dx * 0.58) + 'px,' + (dy * 0.34 - 54) + 'px) scale(.46)',
        opacity: .96, offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: .18 }
    ], { duration: 560, easing: 'cubic-bezier(.2,.8,.2,1)' });

    var aterrizo = false;
    function aterrizar() {
      if (aterrizo) return;
      aterrizo = true;
      g.remove();
      if (icono) rebotar(icono);
    }
    vuelo.finished.catch(function () {}).then(aterrizar);
    /* Y una red de timer, porque `finished` puede no resolver NUNCA: Chrome pausa
       las animaciones de una pestaña oculta o de una ventana tapada por otra, y
       ahi el fantasma se quedaria clavado en pantalla. Medido el 2026-08-25. */
    setTimeout(aterrizar, 900);
    return vuelo.finished.catch(function () {});
  }

  /* --- el <form> deja de navegar ------------------------------------------ */
  Array.prototype.forEach.call(document.querySelectorAll('[data-vy-forma]'), function (forma) {
    forma.addEventListener('submit', function (e) {
      var boton = forma.querySelector('button[type="submit"]');
      if (!boton) return;                       // sin boton no hay nada que interceptar
      e.preventDefault();

      var suelta = function () {
        boton.classList.remove('vy-btn--cargando');
        boton.removeAttribute('aria-busy');
      };
      /* El spinner lo pone veyra-tienda.js en su propio manejador de submit, que
         sigue corriendo: preventDefault detiene la navegacion, no a los demas
         oyentes. Aqui solo se apaga cuando esto termina. */

      var vuelo = volar(forma, boton);

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(forma),
        headers: { 'Accept': 'application/javascript' }
      }).then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return repintar();
      }).then(function () {
        /* EL CAJON NO PUEDE DEPENDER DE QUE LA ANIMACION TERMINE. Encontrado el
           2026-08-25 persiguiendo por que a veces se anadia el producto y el
           cajon no abria nunca: si la ventana queda tapada por otra, Chrome
           pausa la animacion y `vuelo.finished` no resuelve jamas. La compra
           quedaba hecha y sin decirlo, que es exactamente el fallo silencioso
           que este trabajo venia a quitar.

           Se espera al vuelo, pero contra un cronometro: lo que llegue antes.
           `setTimeout` si dispara en una pestana oculta —throttled, pero
           dispara—, asi que la carrera siempre termina. */
        return Promise.race([vuelo, new Promise(function (r) { setTimeout(r, 700); })]);
      }).then(function () {
        suelta();
        abrir();
      }).catch(function () {
        /* Red caida, 422 de inventario, lo que sea. Se deja que el navegador
           haga el POST de siempre: acaba en /cart o en el error de Shopify,
           que es exactamente lo que pasaba antes de que existiera este archivo. */
        suelta();
        forma.submit();
      });
    });
  });

  /* --- cantidad y quitar, dentro del cajon --------------------------------
     Delegado sobre el cajon y no sobre cada boton: el contenido se reemplaza
     entero en cada cambio, asi que un oyente por boton se pierde al primer
     repintado. */
  cajon.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vy-linea-cant]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;

    // Se bloquea la fila entera: dos clics seguidos mandan dos change.js con la
    // misma cantidad de partida y el segundo deshace al primero.
    var fila = b.closest('.vy-bolsa__item') || cajon;
    Array.prototype.forEach.call(fila.querySelectorAll('button'), function (x) { x.disabled = true; });
    cajon.classList.add('vy-bolsa--ocupada');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ id: b.getAttribute('data-vy-linea-cant'),
                             quantity: parseInt(b.getAttribute('data-vy-a'), 10) })
    }).then(function (r) {
      if (!r.ok) throw new Error('change ' + r.status);
      return repintar();
    }).catch(function () {
      window.location.href = '/cart';       // que lo arregle la pagina de carrito
    }).then(function () {
      cajon.classList.remove('vy-bolsa--ocupada');
    });
  });

  /* --- Subir de plan · 2026-10-07 ----------------------------------------
     Mismo orden que el cambio a suscripción: primero se agrega el plan nuevo y
     SOLO si entró se quita la línea vieja. Lo peor que puede pasar es una línea
     duplicada que el comprador ve y quita; nunca una bolsa vacía. */
  cajon.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vy-subir]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true;
    b.classList.add('vy-btn--cargando');
    cajon.classList.add('vy-bolsa--ocupada');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-vy-var'), 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add ' + r.status);
      /* LALO 3.0: sin llave = solo agregar (el «+» sobre una línea de 2 bolsas). */
      if (!b.getAttribute('data-vy-key')) return null;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({ id: b.getAttribute('data-vy-key'), quantity: 0 })
      });
    }).then(function () {
      return repintar();
    }).catch(function () {
      window.location.href = '/cart';
    }).then(function () {
      cajon.classList.remove('vy-bolsa--ocupada');
    });
  });

  /* --- Cambiar una linea a suscripcion · 2026-09-09 -----------------------
     `/cart/change.js` NO puede anadir un `selling_plan` a una linea que no lo
     tiene: hay que crear la linea nueva y borrar la vieja.

     EL ORDEN IMPORTA. Primero `add`, despues `change` a 0. Al reves, si el
     `add` falla el comprador se queda con la bolsa VACIA y sin saber por que.
     Asi, lo peor que puede pasar es una linea duplicada que el mismo ve y quita.

     Delegado sobre el cajon, como el resto: el contenido se reemplaza entero en
     cada repintado y un oyente por boton se pierde al primero. */
  cajon.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vy-suscribir]');
    if (!b || b.disabled) return;
    e.preventDefault();

    b.disabled = true;
    b.classList.add('vy-btn--cargando');
    cajon.classList.add('vy-bolsa--ocupada');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: [{
        id: parseInt(b.getAttribute('data-vy-var'), 10),
        quantity: parseInt(b.getAttribute('data-vy-cant'), 10) || 1,
        selling_plan: parseInt(b.getAttribute('data-vy-plan'), 10)
      }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add ' + r.status);
      /* La linea de compra unica se va SOLO si la de suscripcion ya entro. */
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({ id: b.getAttribute('data-vy-key'), quantity: 0 })
      });
    }).then(function () {
      return repintar();
    }).catch(function () {
      window.location.href = '/cart';       // que lo arregle la pagina de carrito
    }).then(function () {
      cajon.classList.remove('vy-bolsa--ocupada');
    });
  });
})();
